import React, { useContext, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Text, View } from '@/styles/reactnative';
import { CInput } from '@app/components/Common';
import DepositCoinLists from './DepositCoinLists';
import CustomCoinComp from './CustomCoinComp';
import { useDepositStore } from '../../../../hooks/deposit/store';
import { ThemeContext } from '../../../../../theme/ThemeProvider';
import { Select } from 'antd';
import styled from 'styled-components';
import { useFetcherPublic } from '@app/hooks/fetcher.tsx';

const DepositCoins = () => {
  const ref = useRef<HTMLInputElement>(null);
  const { t } = useTranslation();
  const [modal, setModal] = useState(true);
  const { data: depositStore, mutate } = useDepositStore({
    network: 'TRC20',
    coin: 'USDT',
  });
  const { textw } = useContext(ThemeContext).theme.COLORS;

  const search = depositStore?.coin;

  const handleChange = (event: any) => {
    mutate({ ...depositStore, coin: event.target.value });
    setModal(false);
  };

  const { data: res } = useFetcherPublic('/exchanges/coins');

  console.log('res', res);

   
  const tempdata = res?.result?.result?.filter(
    (item: any) => item.deposit == 1
  );

  console.log('tempdata', tempdata);

  return (
    <View
      style={{
        width: '100%',
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
        marginBottom: 10,
      }}
    >
      <Text size={14}>{t('coin')}</Text>
      <StyleSelect defaultValue={search} onChange={handleChange} >
        {tempdata?.map((item: any, index) => (
          <Select.Option key={index.toString()} value={item?.symbol}>
            {item?.symbol}
          </Select.Option>
        ))}
      </StyleSelect>
      {/*<CInput*/}
      {/*  ref={ref}*/}
      {/*  placeholder={t('searchCoin')}*/}
      {/*  value={search}*/}
      {/*  type={'text'}*/}
      {/*  onClick={() => {*/}
      {/*    console.log('click');*/}
      {/*    setModal(!modal);*/}
      {/*  }}*/}
      {/*  onChange={handleChange}*/}
      {/*  vStyle={{ width: '100%' }}*/}
      {/*  CustomComp={false ? <CustomCoinComp /> : null}*/}
      {/*  style={{*/}
      {/*    flexDirection: 'row',*/}
      {/*    border: `1px solid #007AFF`,*/}
      {/*    marginTop: 10,*/}
      {/*    width: '100%',*/}
      {/*    justifyContent: 'space-between',*/}
      {/*    padding: 8,*/}
      {/*    borderRadius: 5,*/}
      {/*    cursor: 'pointer',*/}
      {/*    background: 'transparent',*/}
      {/*    color: textw,*/}
      {/*  }}*/}
      {/*  readonly={true}*/}
      {/*/>*/}
      {/*{search?.length && !modal ? (*/}
      {/*  <DepositCoinLists setModal={setModal} />*/}
      {/*) : null}*/}
    </View>
  );
};

export default DepositCoins;

const StyleSelect = styled(Select)`
    width: 100%;
    margin-top: 10px;
`